import React, { createContext, useReducer } from "react";
import { chatReducer } from "./chatReducer";

export const ChatContext = createContext();

const initialState = {
  // Dashboard
  agentStats: [], // Estadisticas de los agentes
  totalBotMessages: 0, // Total de mensajes del bot
  totalAgentMessages: 0, // Total de mensajes de los agentes
  unreadMessages: 0, // Total de mensajes no leidos
  chatOnHold: 0, // Chats en espera
  estDash: {}, // Datos de Gupshup
  answers: [], // Respuestas rapidas
  // Chat
  chatList: [], // Lista de chats
  chatsLists: [], // Lista de chats por categorias
  messages: [], // Historial de mensajes
  activeChat: null, // Chat activo
  activeChatTab: null, // Chat activo
  // Configuracion
  colorMode: "light", // Modo de color
};

/**
 * Proveedor del contexto de chat
 *
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.children - Componentes hijos
 * @returns {JSX.Element} Componente de React
 */
export const ChatProvider = ({ children }) => {
  const [chatState, dispatch] = useReducer(chatReducer, initialState);

  return (
    <ChatContext.Provider
      value={{
        chatState,
        dispatch,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
